// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"8b9dac17","506":"3728bd03","769":"426d7d46","948":"2a90a4e4"}[chunkId] + ".chunk.js";
};